(function (f, b, e, v, n, t, s) {
  if (f.fbq) return
  n = f.fbq = function () {
    n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
  }
  if (!f._fbq) f._fbq = n
  n.push = n
  n.loaded = !0
  n.version = '2.0'
  n.queue = []
  t = b.createElement(e)
  t.async = !0
  t.src = v
  s = b.getElementsByTagName(e)[0]
  s.parentNode.insertBefore(t, s)
})(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js')

window.fbq('init', '1382843076682543')

/**
 * Meta Pixel 标准事件
 * @param {string} eventName
 * @param {object} [params]
 */
export function trackFbEvent (eventName, params = {}) {
  if (typeof window.fbq === 'function') {
    window.fbq('track', eventName, params)
  } else {
    logger.debug('Meta Pixel (fbq) 未加载成功')
  }
}

/**
 * Meta Pixel 自定义事件
 * @param {string} eventName
 * @param {object} [params]
 */
export function trackFbCustomEvent (eventName, params = {}) {
  if (typeof window.fbq === 'function') {
    window.fbq('trackCustom', eventName, params)
  } else {
    logger.debug('Meta Pixel (fbq) 未加载成功')
  }
}

if (typeof window !== 'undefined') {
  window.trackFbEvent = trackFbEvent
  window.trackFbCustomEvent = trackFbCustomEvent
}
